import { render, staticRenderFns } from "./simPackage.vue?vue&type=template&id=2cf9761d&scoped=true"
import script from "./simPackage.vue?vue&type=script&lang=js"
export * from "./simPackage.vue?vue&type=script&lang=js"
import style0 from "./simPackage.vue?vue&type=style&index=0&id=2cf9761d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9761d",
  null
  
)

export default component.exports